import { IBasicdetails } from '@/shared/types/shared-types';
import ApiServiceWrapper from './../../api-request.service';
import { MswApiStatusResponse } from '@/shared/types/api-common-types';

const widgetsApi = {
  getUserMgmt() {
    const reqEndPoint = 'users/get-usermanagement-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
  getLicenseStatus() {
    const reqEndPoint = 'users/licensestatus-widget-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
  getDownloadsAvailable() {
    const reqEndPoint = 'users/downloads-widget-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
  getSupportCases() {
    const reqEndPoint = 'support/get-supportcase-widget-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
  updateBaseDetails(payload: IBasicdetails) {
    const reqEndPoint = 'users/update-basicdetails';
    return ApiServiceWrapper.post<MswApiStatusResponse>(reqEndPoint, payload);
  },
};

export default widgetsApi;
